/* eslint-disable */
import * as Yup from 'yup';
import { useState } from 'react';
import { Link as RouterLink, useNavigate, useHref } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// material
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import services from './Service';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
// import { messaging } from '../../../firebase';
// import { getToken } from 'firebase/messaging';
// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [loginData, setloginData] = useState({
    username: "",
    password: ""
  });

  const LoginSchema = Yup.object().shape({
    username: Yup.string().required('User Name is required'),
    password: Yup.string().required('Password is required')
  });


  async function login(values) {
    const result = await services.login(values);
    if (result.statusCode === "Error") {
      toast.error(result.message);
      setloginData({
        username: "",
        password: ""
      })
      // setIsHidden(true);
      // setmessageModel(result.message);
      return;
    }
    sessionStorage.setItem('token', result.data);
    //requestPermissions();
    toast.success("Succesfully Logged In");
    navigate('/loader');
  }

  // async function requestPermissions() {
  //   const permission = await Notification.requestPermission()
  //   if (permission === 'granted') {
  //     //Granted token
  //     const token = await getToken(messaging, {
  //       vapidKey: "BAApBq2n8QuPSk1JDyBZ40HBVplkXCHAZjlMW-V_2M0UjuaBuGW3az-Lk0diRzFKGd5ZID5HUYLqJnJTOFp0evo"
  //     });
  //     await services.registerToken(token);
  //     sessionStorage.setItem('firebaseToken', token);
  //   } else if (permission == 'denied') {
  //     console.log('Notification acces denied')
  //   }
  // }

  const formik = useFormik({
    initialValues: {
      username: loginData.username,
      password: loginData.password,
      remember: true
    },
    validationSchema: LoginSchema,
    onSubmit: (values) => {
      trackPromise(login(values));
    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  return (
    <>
      <LoadingComponent />
      <FormikProvider value={formik}>
        <ToastContainer
          position="bottom-right"
          pauseOnHover
        />
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              autoComplete="username"
              type="email"
              label="User Name"
              onChange={formik.handleChange}
              value={formik.values.username}
              {...getFieldProps('username')}
              error={Boolean(touched.username && errors.username)}
              helperText={touched.username && errors.username}
            />

            <TextField
              fullWidth
              autoComplete="current-password"
              type={showPassword ? 'text' : 'password'}
              label="Password"
              onChange={formik.handleChange}
              value={formik.values.password}
              {...getFieldProps('password')}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleShowPassword} edge="end">
                      <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              error={Boolean(touched.password && errors.password)}
              helperText={touched.password && errors.password}
            />
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
            <FormControlLabel
              control={<Checkbox color='primary' {...getFieldProps('remember')} checked={values.remember} />}
              label="Remember me"
            />
          </Stack>

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            color='primary'
            variant="contained"
          >
            Login
          </LoadingButton>
        </Form>
      </FormikProvider>
    </>
  );
}
